import { useTranslation } from 'react-i18next';
import { NotReady } from '../../../../components/NotReady/NotReady';
import { PublicSurveyLoading } from '../PublicSurveyLoading/PublicSurveyLoading';
import type { ErrorType } from '../../logic/ErrorStateResolver';

export interface ErrorContentProps {
  errorType: ErrorType;
}

export const ErrorContent = ({ errorType }: ErrorContentProps) => {
  const { t } = useTranslation();

  switch (errorType) {
    case 'loading':
      return <PublicSurveyLoading />;

    case 'notReady':
      return (
        <NotReady
          title={t('publicSurvey.errors.notReady.title')}
          description={t('publicSurvey.errors.notReady.description')}
        />
      );

    case 'loadError':
      return (
        <NotReady
          title={t('publicSurvey.errors.loadError.title')}
          description={t('publicSurvey.errors.loadError.description')}
        />
      );

    case 'notFound':
      return (
        <NotReady
          title={t('publicSurvey.errors.notFound.title')}
          description={t('publicSurvey.errors.notFound.description')}
        />
      );

    case 'noData':
      return (
        <NotReady
          title={t('publicSurvey.errors.waitingForData.title')}
          description={t('publicSurvey.errors.waitingForData.description')}
        />
      );

    default:
      return null;
  }
};
